/* Keep the third-party Wishlist by Square button functional. Move its
   existing control into the product details corner instead of cloning it.
   Never move an element if its container includes product information. */
(()=> {
  const MARKER='av-product-wishlist-fixed';
  function positionWishlist(){
    const details=document.querySelector('.product-information .product-details');
    const card=details?.querySelector(':scope > .group-block');
    if(!details||!card||card.querySelector('.'+MARKER)) return;
    const matches=details.querySelectorAll(
      '[class*="wishlist" i],[id*="wishlist" i],[aria-label*="wishlist" i],[title*="wishlist" i],[class*="sqwish" i],[aria-label*="lemmik" i]'
    );
    let button=null;
    for(const m of matches){
      const el=m.matches('button,a,[role="button"]')
       ?m:(m.closest('button,a,[role="button"]')||m.querySelector('button,a,[role="button"]'));
      if(!el||!details.contains(el)||el.closest('.'+MARKER)) continue;
      if(el.closest('.product-information__media')) continue;
      // Avoid accidentally targeting unrelated headings or embedded app modals.
      if(el.closest('h1,product-price,.product-form-buttons')) continue;
      button=el;break;
    }
    if(!button) return;
    let target=button;
    for(let parent=button.parentElement;parent&&parent!==card&&parent!==details;parent=parent.parentElement){
      if(parent.querySelector('h1,product-price,.product-form-buttons')) break;
      const actionCount=parent.querySelectorAll('button,a,[role="button"]').length;
      if(actionCount>1||parent.textContent.trim().length>100) break;
      target=parent;
    }
    if(target===card||target===details||target.querySelector('h1,product-price,.product-form-buttons')) return;
    card.appendChild(target);
    target.classList.add(MARKER);
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',positionWishlist,{once:true});
  else positionWishlist();
  [400,1000,2400,4500].forEach(delay=>setTimeout(positionWishlist,delay));
})();